export const KRON_LIGHT = 'kron-light';
export const KRON_DARK = 'kron-dark';
export const DISPLAY_MODE_KEY = 'displaymode';
export const DATA_THEME_KEY = 'data-theme';

export default function generateCorrelationId() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}

export function extractFmsSlug(fmsKey: string): string {
  const segments = fmsKey.split('.');
  return segments[segments.length - 1];
}

export function generatePdfFilename({
  id,
  name,
  contractNumbers,
  date,
}: {
  id?: string;
  name?: string;
  contractNumbers?: string[];
  date?: string;
}): string {
  const parts = [
    name?.replace(/\.pdf$/i, '') || null,
    contractNumbers && contractNumbers.length > 0
      ? contractNumbers.join('_')
      : null,
    date || null,
  ].filter(Boolean);

  return parts.length > 0
    ? `${parts.join('_')}.pdf`
    : `${id ?? 'document'}.pdf`;
}

const getLowercaseKeyUrlSearchParams = (
  urlSearchParams: URLSearchParams
): URLSearchParams => {
  const lowerCaseEntries = Array.from(urlSearchParams.entries()).map(
    ([key, value]) => [key.toLowerCase(), value]
  );
  return new URLSearchParams(lowerCaseEntries);
};

export const getParamFromUrl = (param: string): string => {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const searchParams = new URLSearchParams(search);
  const params = getLowercaseKeyUrlSearchParams(searchParams);
  return params.get(param) ?? '';
};

export const getThemeFromSessionStorage = (): string | null =>
  typeof sessionStorage !== 'undefined'
    ? sessionStorage.getItem('theme')
    : null;

export const storeThemeInSessionStorage = (theme: string): void => {
  sessionStorage.setItem('theme', theme);
};

export const storeDisplayModeInSessionStorage = (mode: string): void => {
  sessionStorage.setItem('displayMode', mode);
};

export const getCurrentTheme = () =>
  getThemeFromSessionStorage() ?? getParamFromUrl('theme');

export const displayMode: string | null =
  getParamFromUrl(DISPLAY_MODE_KEY) || sessionStorage.getItem('displayMode');
export const isApp: boolean = displayMode === 'app';
export const isKronWebApp: boolean = [KRON_LIGHT, KRON_DARK].includes(
  getCurrentTheme()
);
